import React, { useState, useEffect } from "react";
import { Container, Row, Col } from "react-bootstrap";
import { useDispatch, useSelector } from "react-redux";
import { ActionButton, Buttons } from "../../components/Buttons";
import { MdOutlineDelete } from "react-icons/md";
import { LiaEditSolid } from "react-icons/lia";
import {
  fetchStaff,
  addStaff,
  updateStaff,
  deleteStaff,
} from "../../slice/StaffSlice";
import { HiOutlineDotsVertical } from "react-icons/hi";
import PageTitle from "../../components/PageTitle";
import CustomModal from "../../components/Modal";
import NotifyData from "../../components/NotifyData";
import StaffCreation from "../creations/StaffCreation";
import { TextInputform } from "../../components/Forms";
import TableUI from "../../components/TableUI";
import Pagination from "../../components/Pagination";

const Staff = () => {
  const dispatch = useDispatch();
  const { staff, status, error } = useSelector((state) => state.staff);

  const userData = JSON.parse(localStorage.getItem("user")) || {};
  const currentUserId = userData.user_id;

  const staffSchema = [
    { name: "staff_name", label: "Staff Name", type: "text", required: true },
    {
      name: "staff_no",
      label: "Staff Number",
      type: "text",
      required: true,
      disabled: true,
    },
    {
      name: "mobile_number",
      label: "Mobile Number",
      type: "text",
      required: true,
    },
    { name: "password", label: "Password", type: "password", required: true },
  ];

  const [formData, setFormData] = useState({
    staff_name: "",
    staff_no: "",
    mobile_number: "",
    password: "",
  });
  console.log(formData);
  const [show, setShow] = useState(false);
  const [editMode, setEditMode] = useState(false);
  const [selectedStaff, setSelectedStaff] = useState(null);
  const [searchTerm, setSearchTerm] = useState("");
  const [isSubmitting, setIsSubmitting] = useState(false);

  const [currentPage, setCurrentPage] = useState(1);
  const [itemsPerPage, setItemsPerPage] = useState(10);

  const handleOpen = () => setShow(true);
  const handleClose = () => setShow(false);

  useEffect(() => {
    dispatch(fetchStaff(searchTerm));
  }, [dispatch, searchTerm]);

  const handleEdit = (staff) => {
    setEditMode(true);
    setSelectedStaff(staff || {});
    setFormData({
      staff_name: staff?.staff_name || "",
      staff_no: staff?.staff_no || "",
      mobile_number: staff?.mobile_number || "",
      password: staff?.password || "",
    });
    handleOpen();
  };

  const handleCreate = () => {
    setEditMode(false);
    setFormData({
      staff_name: "",
      staff_no: "",
      mobile_number: "",
      password: "",
    });
    handleOpen();
  };

  const handleSubmit = async () => {
    if (
      !formData.staff_name ||
      !formData.staff_no ||
      !formData.mobile_number ||
      !formData.password
    ) {
      NotifyData("Staff Creation Failed: All fields are required", "error");
      return;
    }

    if (!currentUserId) {
      NotifyData("Operation Failed: User not authenticated", "error");
      return;
    }

    setIsSubmitting(true);

    const staffData = { ...formData, current_user_id: currentUserId };

    try {
      const msg = await dispatch(addStaff(staffData)).unwrap();
      NotifyData(msg, "success");
      dispatch(fetchStaff(searchTerm));
      handleClose();
      setFormData({
        staff_name: "",
        staff_no: "",
        mobile_number: "",
        password: "",
      });
      setEditMode(false);
    } catch (error) {
      NotifyData(error.message, "error");
    } finally {
      setIsSubmitting(false);
    }
  };

  const handleUpdate = async () => {
    if (
      !formData.staff_name ||
      !formData.staff_no ||
      !formData.mobile_number ||
      !formData.password
    ) {
      NotifyData("Staff Update Failed: All fields are required", "error");
      return;
    }

    if (!currentUserId || !selectedStaff?.staff_id) {
      NotifyData("Staff Update Failed: Invalid data", "error");
      return;
    }

    setIsSubmitting(true);

    const staffData = {
      ...formData,
      current_user_id: currentUserId,
      staff_id: selectedStaff.staff_id,
    };

    try {
      const msg = await dispatch(updateStaff(staffData)).unwrap();
      NotifyData(msg, "success");
      dispatch(fetchStaff(searchTerm));
      handleClose();
      setFormData({
        staff_name: "",
        staff_no: "",
        mobile_number: "",
        password: "",
      });
      setEditMode(false);
    } catch (error) {
      NotifyData(error.message, "error");
    } finally {
      setIsSubmitting(false);
    }
  };

  const handleDelete = async (staffId) => {
    if (!currentUserId) {
      NotifyData("Operation Failed: User not authenticated", "error");
      return;
    }

    try {
      const msg = await dispatch(
        deleteStaff({ staffId, currentUserId })
      ).unwrap();
      NotifyData(msg, "success");
      dispatch(fetchStaff(searchTerm));
    } catch (error) {
      NotifyData(error.message, "error");
    }
  };

  const filteredStaff =
    staff?.filter((s) =>
      s?.staff_name?.toLowerCase()?.includes(searchTerm.toLowerCase())
    ) || [];

  const totalRecords = filteredStaff.length;
  const totalPages = Math.ceil(totalRecords / itemsPerPage);

  const paginatedData = filteredStaff.slice(
    (currentPage - 1) * itemsPerPage,
    currentPage * itemsPerPage
  );

  const StaffHead = ["No", "Staff Name", "Staff Number", "Mobile Number"];

  return (
    <div id="main">
      <Container fluid>
        <Row>
          <Col xs="6" className="py-3">
            <PageTitle PageTitle="Staff" showButton={false} />
          </Col>
          <Col xs="6" className="py-3 text-end">
            <Buttons
              btnlabel="Add New"
              className="add-btn"
              onClick={handleCreate}
            />
          </Col>
          <Col xs="12" lg="3" className="py-3">
            <TextInputform
              textlabel="Search Staff"
              PlaceHolder="Search by staff name"
              value={searchTerm}
              onChange={(e) => setSearchTerm(e.target.value)}
            />
          </Col>

          <Col xs="12" className="d-flex justify-content-end">
            <Pagination
              currentPage={currentPage}
              totalPages={totalPages}
              onPageChange={setCurrentPage}
            />
          </Col>
          {/* ✅ Table with pagination */}
          <Col xs="12" className="py-3 tableui">
            <TableUI
              headers={StaffHead}
              body={paginatedData.map((item, index) => ({
                key: item.staff_id,
                values: [
                  (currentPage - 1) * itemsPerPage + index + 1, // continuous serial no
                  item.staff_name,
                  item.staff_no,
                  item.mobile_number,
                  <ActionButton
                    options={[
                      {
                        label: "Edit",
                        icon: <LiaEditSolid />,
                        onClick: () => handleEdit(item),
                      },
                      {
                        label: "Delete",
                        icon: <MdOutlineDelete />,
                        onClick: () => handleDelete(item.staff_id),
                      },
                    ]}
                    label={<HiOutlineDotsVertical />}
                  />,
                ],
              }))}
            />
          </Col>
        </Row>
      </Container>

      <CustomModal
        show={show}
        setShow={setShow}
        pageTitle={editMode ? <>Edit Staff</> : <>Create Staff</>}
        showButton={true}
        submitButton={true}
        submitLabel={
          isSubmitting
            ? editMode
              ? "Updating..."
              : "Submitting..."
            : editMode
            ? "Update"
            : "Submit"
        }
        CancelLabel="Cancel"
        BodyComponent={
          <StaffCreation
            formData={formData}
            setFormData={setFormData}
            schema={staffSchema}
            editMode={editMode}
          />
        }
        OnClick={editMode ? handleUpdate : handleSubmit}
        Size="md"
        handleOpen={handleOpen}
        handleClose={handleClose}
        isSubmitting={isSubmitting}
      />
    </div>
  );
};

export default Staff;
